import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Typography } from '@mui/material';
import IncButton from 'components/inc-button/inc-button.component';
import React, { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { requestPwReset } from 'redux/user/user.actions';
import Form from '../form/form.component';
import Spinner from '../spinner/spinner.component';
import EmailField from './fields/email.component';
import PhoneField from './fields/phone.component';
import { forgotPasswordSchema } from './forgot-password.schema';

const ForgotPassword = ({ send, email, phone }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const methods = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onBlur',
    resolver: yupResolver(forgotPasswordSchema),
    defaultValues: {
      email,
      phone,
    },
  });
  const { handleSubmit } = methods;

  const onSubmitWrapper = async data => {
    setIsLoading(true);
    const res = await dispatch(requestPwReset(data));
    setIsLoading(false);
    if (res.status === 200) {
      const values = methods.getValues();
      send('SUCCESS', {
        data: {
          contact: res.data.contact,
          email: values.email,
          phone: values.phone,
        },
      });
    }
  };

  return (
    <FormProvider {...methods}>
      <Box
        component={Form}
        onSubmit={handleSubmit(onSubmitWrapper)}
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        flex={1}
        minHeight="400px"
      >
        <Box display="grid" rowGap={theme => theme.spacing(1)}>
          <Typography gutterBottom variant="body1">
            {t('forgotPassword.subTitle')}
          </Typography>
          <Box display="grid" rowGap={theme => theme.spacing(1)}>
            {isLoading && <Spinner />}
            <EmailField name="email" />
            <Box justifySelf="center" mt={1}>
              <Typography>-{t('forgotPassword.or')}-</Typography>
            </Box>
            <PhoneField name="phone" />
          </Box>
        </Box>
        <Box display="grid" rowGap={theme => theme.spacing(1)}>
          <Typography variant="body2">
            {t('forgotPassword.activationMessage')}
          </Typography>
          <IncButton type="submit" fullWidth>
            {t('forgotPassword.label.submit')}
          </IncButton>
        </Box>
      </Box>
    </FormProvider>
  );
};

export default ForgotPassword;
